import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {ProjectSettings} from "../../../../core/models";
import {SelectItem} from "primeng/api";

@Component({
  selector: 'app-project-setting',
  templateUrl: './project-setting.component.html'
})
export class ProjectSettingComponent implements OnInit {

  @Input() projectSetting: ProjectSettings;
  @Output() projectSettingChange: EventEmitter<ProjectSettings> = new EventEmitter<ProjectSettings>();
  @Input() touched: boolean;
  @Output() touchedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  selectItems: SelectItem[] = null;
  value: any = null;

  constructor() {
  }

  ngOnInit() {
    if (this.projectSetting.projectSettingType === 'BOOLEAN') {
      if (this.projectSetting.nullable) {
        this.selectItems = [
          {label: 'null', value: null},
          {label: 'false', value: 'false'},
          {label: 'true', value: 'true'},
        ];
      } else {
        this.selectItems = [
          {label: 'false', value: 'false'},
          {label: 'true', value: 'true'},
        ];
      }
      this.value = this.projectSetting.value === null ? 'null' : this.projectSetting.value;
    }
    else if (this.projectSetting.projectSettingType === 'INTEGER') {
      if (this.projectSetting.value !== null) {
        this.value = this.projectSetting.value;
      }
      this.value = this.projectSetting.value === null ? 'null' : parseInt(this.projectSetting.value);
    }
  }

  onTouch(event: any) {
    this.touched = true;
    this.touchedChange.emit(this.touched);

    if (this.projectSetting.projectSettingType === 'BOOLEAN') {
      this.projectSetting.value = event.value === null ? null : event.value + '';
    } else if (this.projectSetting.projectSettingType === 'INTEGER') {
      this.projectSetting.value = event === null ? null : event + '';
    }
    this.projectSettingChange.emit(this.projectSetting);
  }

}

